import React from 'react';
import './userWorkoutsCalendar.css';
import { useDispatch, useSelector } from "react-redux";
import { getLastBookingSagaAction } from "../../redux/sagaActions";
import LastBookingForm from "../LastBookingForm/LastBookingForm";

const UserWorkoutsCalendar = () => {
    const dispatch = useDispatch();
    const currentUser = useSelector(state => state.currentUser);
    const last_booking_form = useSelector(state => state.last_booking_form);

    return (
        <div className="user__calendar-wrapper">
            { last_booking_form.open && <LastBookingForm/> }
            <div className="user__calendar-caption">
                <div className="user__calendar-caption-item user__calendar-caption-item--workout">Тренировки</div>
                <div className="user__calendar-caption-item user__calendar-caption-item--booking"
                     onClick={ () => dispatch(getLastBookingSagaAction({
                         user: currentUser.id
                     })) }
                >Записи</div>
            </div>
            <div className="user__calendars">
                {
                    currentUser.workouts_calendar.map((elem, index) => {
                        return (
                            <div className="user__calendar" key={ index }>
                                <div className="user__calendar-month">{ elem.name }</div>
                                <div className="user__calendar-days">
                                    <div className="user__calendar-day">Пн</div>
                                    <div className="user__calendar-day">Вт</div>
                                    <div className="user__calendar-day">Ср</div>
                                    <div className="user__calendar-day">Чт</div>
                                    <div className="user__calendar-day">Пт</div>
                                    <div className="user__calendar-day user__calendar-day--weekend">Сб</div>
                                    <div className="user__calendar-day user__calendar-day--weekend">Вс</div>
                                </div>
                                <div className="user__calendar-dates">
                                    {
                                        elem.dates.map(el => {
                                            return <div
                                                className={ `user__calendar-date ${ el.workout ? 'user__calendar-date--workout' : '' } ${ el.booking ? 'user__calendar-date--booking' : '' }` }
                                                key={ el.id }
                                            >{ el.day }</div>
                                        })
                                    }
                                </div>
                            </div>
                        );
                    })
                }
            </div>
        </div>
    );
};

export default UserWorkoutsCalendar;